import { IListModelQueryParamValues, IModelJsonValues } from '@sparelabs/http-client-utils'
import { IRequestAccessibilityFeature } from './AccessibilityTypes'
import { IRequestRiderType } from './RequestRiderTypes'

export enum RiderRepresentativeStatus {
  Active = 'active',
  Archived = 'archived',
  Pending = 'pending',
}

export interface IRiderRepresentativeResponse extends IModelJsonValues {
  representeeId: string
  representativeId: string
  status: RiderRepresentativeStatus
}

export interface IRiderRepresentativeListQueryParams extends IListModelQueryParamValues {
  representeeId?: string
  representativeId?: string
  status?: RiderRepresentativeStatus
}

export interface IRiderRepresentativePostBody {
  representeeId: string
  representativeId: string
}

export interface IRiderRepresentativePatchBody {
  status?: RiderRepresentativeStatus
}

export interface IRiderMeRepresenteeItem {
  id: string
  firstName: string | null
  lastName: string | null
  photoUrl: string | null
  phoneNumber: string | null
  email: string | null
  defaultRiders: IRequestRiderType[] | null
  defaultAccessibilityFeatures: IRequestAccessibilityFeature[] | null
  defaultNotes: string | null
  defaultRequestMetadata: Record<string, unknown>
}

export interface IRiderMeRepresenteeResponse {
  data: Array<{
    representee: IRiderMeRepresenteeItem
  }>
}

export enum IRiderMeRepresenteeLookupMethod {
  PhoneNumber = 'phoneNumber',
  Email = 'email',
  RiderId = 'riderId',
  None = 'none',
}

export interface IRiderMeRepresenteePostBody {
  lookupMethod: IRiderMeRepresenteeLookupMethod
  phoneNumber?: string
  email?: string
  externalNumericId?: number
  phonePin?: string
  caseTemplateName?: string
}

export interface IRiderMeRepresenteePostResponse {
  riderId: string
  status: RiderRepresentativeStatus
}

export interface IRiderRepresentativeSMSResponsePostBody {
  phoneNumber: string
  message: string
}

export interface IRiderRepresentativeSMSResponsePostResponse {
  message: string
}

export interface IRiderRepresentativeApprovalPostResponse {
  success: boolean
  message: string
  representativeName?: string
}
